<script lang="ts">
	import type { i18n } from 'types/common'

	import Pin from 'components/search/Pin.svelte'
	import Input from '@isoftdata/svelte-input'
	import { getContext } from 'svelte'

	interface Props {
		to?: string
		from?: string
		label?: string
		disabled?: boolean
		isPinned?: boolean
		id?: string
		change?: (value: { from: string; to: string }) => void
	}

	let {
		to = $bindable(''),
		from = $bindable(''),
		label = '',
		disabled = false,
		isPinned = false,
		id = '',
		change,
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

<label
	class="col-form-label pb-0"
	for={id}
	>{label} <Pin {isPinned} />
</label>
<div class="row">
	<div class="col-12 col-md-6">
		<Input
			{id}
			{disabled}
			label={translate('common:from', 'From')}
			bind:value={from}
			onchange={() => {
				if (from && !to) {
					to = from
				}
				change?.({ from, to })
			}}
		/>
	</div>

	<div class="col-12 col-md-6">
		<Input
			{disabled}
			label={translate('common:to', 'To')}
			bind:value={to}
			onchange={() => change?.({ from, to })}
		/>
	</div>
</div>
